/**
 * StatusBadge — pastel pill for startup/investor pipeline status.
 */
const COLOR_MAP = {
  // Startups
  submitted: "bg-skyMist text-cocoa",
  in_review: "bg-lavenderFog text-cocoa",
  deck_uploaded: "bg-skyMist text-cocoa",
  ai_analysis_completed: "bg-sageMint text-cocoa",
  qualified: "bg-sageMint text-cocoa",
  meeting_requested: "bg-butterCream text-cocoa",
  meeting_approved: "bg-butterCream text-cocoa",
  meeting_completed: "bg-roseMilk text-cocoa",
  active_network: "bg-roseMilk text-cocoa",
  potential_matchmaker: "bg-roseMilk text-cocoa",
  potential_investor: "bg-roseMilk text-cocoa",
  nurture: "bg-ivory text-warmGrey",
  paused: "bg-ivory text-warmGrey",
  more_info_needed: "bg-butterCream text-cocoa",
  archived: "bg-sandBeige/70 text-warmGrey",
  do_not_contact: "bg-coral/20 text-coral",
  unknown: "bg-ivory text-warmGrey",
};

const HUMAN = {
  submitted: "Submitted",
  in_review: "In Review",
  deck_uploaded: "Deck Uploaded",
  ai_analysis_completed: "AI Done",
  qualified: "Qualified",
  meeting_requested: "Meeting Requested",
  meeting_approved: "Meeting Approved",
  meeting_completed: "Meeting Completed",
  active_network: "Active Network",
  potential_matchmaker: "Potential Matchmaker",
  potential_investor: "Potential Investor",
  nurture: "Nurture",
  paused: "Paused",
  more_info_needed: "More Info Needed",
  archived: "Archived",
  do_not_contact: "Do Not Contact",
};

export const StatusBadge = ({ value, size = "md", testId }) => {
  const v = value || "unknown";
  const cls = COLOR_MAP[v] || COLOR_MAP.unknown;
  const sz = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${cls} ${sz}`}
      data-testid={testId}
    >
      {HUMAN[v] || v}
    </span>
  );
};

export const PIPELINE_STARTUPS = [
  "submitted", "in_review", "deck_uploaded", "ai_analysis_completed",
  "qualified", "meeting_requested", "meeting_approved", "meeting_completed",
  "active_network", "more_info_needed", "archived",
];

export const PIPELINE_INVESTORS = [
  "submitted", "qualified", "meeting_requested", "meeting_approved",
  "meeting_completed", "active_network", "potential_matchmaker",
  "potential_investor", "nurture", "paused", "do_not_contact",
];

export default StatusBadge;
